<span [routerLink]="$safeNavigationMigration((link$ | async)?.link)">{{
  $safeNavigationMigration((link$ | async)?.label) | langPicker | async
}}</span>
